import { render } from "./NewGameInvitation.vue?vue&type=template&id=c25b6d1a"
import script from "./NewGameInvitation.vue?vue&type=script&lang=js"
export * from "./NewGameInvitation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__